"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@8base/utils");
class SubscribableDecorator {
    static hasConflicts(authClient) {
        return (Reflect.has(authClient, 'publisher') ||
            Reflect.has(authClient, 'subscribe') ||
            Reflect.has(authClient, 'notify') ||
            Reflect.has(authClient, 'batch'));
    }
    static decorate(authClient) {
        if (SubscribableDecorator.hasConflicts(authClient)) {
            throw new utils_1.SDKError(utils_1.ERROR_CODES.PROPERTY_CONFLICT, utils_1.PACKAGES.AUTH, "authClient has property conflict, it shouldn't have 'publisher', 'subscribe', 'notify' and 'batch' properties");
        }
        const decoratedAuthClient = {
            publisher: new utils_1.Publisher(),
            subscribe(subscriber) {
                return this.publisher.subscribe(subscriber);
            },
            notify(state) {
                this.publisher.notify(state);
            },
            batch(fn) {
                this.publisher.batch(fn);
            },
            setState(state) {
                super.setState(state);
                // @ts-ignore
                const newState = this.getState();
                this.notify(newState);
            },
            purgeState() {
                super.purgeState();
                // @ts-ignore
                const newState = this.getState();
                this.notify(newState);
            },
        };
        Object.setPrototypeOf(decoratedAuthClient, authClient);
        // @ts-ignore
        return decoratedAuthClient;
    }
}
exports.SubscribableDecorator = SubscribableDecorator;
//# sourceMappingURL=SubscribableDecorator.js.map